import { Injector, PipeTransform } from '@angular/core';
import * as i0 from "@angular/core";
export let DynamicPipe = /*#__PURE__*/(() => {
  class DynamicPipe {
    constructor(injector) {
      this.injector = injector;
    }
    transform(value, pipes) {
      if (!pipes || !pipes.length) return value;
      pipes.forEach(({
        pipe,
        args
      }) => {
        if (!pipe) return;
        const pipeInstance = this.injector.get(pipe);
        if (!Array.isArray(args)) args = [args];
        value = pipeInstance.transform(value, ...args);
      });
      return value;
    }
    static {
      this.ɵfac = function DynamicPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicPipe)(i0.ɵɵdirectiveInject(i0.Injector, 16));
      };
    }
    static {
      this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
        name: "dynamicPipe",
        type: DynamicPipe,
        pure: true
      });
    }
  }
  return DynamicPipe;
})();